<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      clipped
      :expand-on-hover="this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.xl"
      :mini-variant="this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.xl"
      color="#283275"      
      app     
      transition="fade-transition"      
      v-if="usuarioLogado && user.tipo != 'CAIXA' && user.tipo != 'ATENDENTE'"
    >
      <v-list dense v-if="companyobj.logoUrl" class="py-3" style="background-color:white;padding: 7px;">
        <v-img :src="companyobj.logoUrl" max-width="-webkit-fill-available;"></v-img>
      </v-list>

      <v-list dense  class="py-0" >
        <v-list-item  to='/home' @click="textoMenu = 'Dashboard'" active-class="corMenu" >
          <v-list-item-action>
            <v-icon dense medium color="white">dashboard</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Dashboard</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item  to='/empresas' @click="textoMenu = 'Empresas'" active-class="corMenu" v-if="user.tipo == 'ADMIN'">
          <v-list-item-action>
            <v-icon dense medium color="white">mdi-domain</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Empresas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/lojistas' @click="textoMenu = 'Lojistas'" active-class="corMenu" v-if="user.tipo == 'ADMIN' || user.tipo == 'ADMIN_PRODUTORA'">
          <v-list-item-action>
            <v-icon dense medium color="white">mdi-account-group</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Lojistas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/usuarios' @click="textoMenu = 'Usuários'" active-class="corMenu" v-if="user.tipo == 'ADMIN' || user.tipo == 'ADMIN_PRODUTORA'">
          <v-list-item-action>
            <v-icon dense medium color="white">mdi-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Usuários</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/consumidores' @click="textoMenu = 'Consumidores'" active-class="corMenu" v-if="user.tipo == 'ADMIN' || user.tipo == 'ADMIN_PRODUTORA'">
          <v-list-item-action>
            <v-icon dense medium color="white">mdi-account-cash-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Consumidores</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/cartoes' @click="textoMenu = 'Cartoes'" active-class="corMenu" v-if="user.tipo == 'ADMIN' || user.tipo == 'ADMIN_PRODUTORA'">
          <v-list-item-action>
            <v-icon dense medium color="white">mdi-nfc-variant</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Cartões</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group nav dense value="true" v-if="user.tipo == 'ADMIN' || user.tipo == 'ADMIN_LOJISTA' || user.tipo == 'ADMIN_PRODUTORA'">
          <template v-slot:activator>
            <v-list-item-action>
              <v-icon style="color: white">history</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title style="color: white">Histórico</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item to='/recargas' dark color="white" v-if="user.tipo == 'ADMIN' || user.tipo == 'ADMIN_PRODUTORA'">
            <v-list-item-action>
              <v-icon dense medium color="white">mdi-cash-plus</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Recargas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/consumos" dark color="white" v-if="user.tipo == 'ADMIN' || user.tipo == 'ADMIN_LOJISTA' || user.tipo == 'ADMIN_PRODUTORA'">
            <v-list-item-action>
              <v-icon dense medium color="white">mdi-cash-minus</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Consumo</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/consumositem" dark color="white" v-if="user.tipo == 'ADMIN' || user.tipo == 'ADMIN_LOJISTA' || user.tipo == 'ADMIN_PRODUTORA'">
            <v-list-item-action>
              <v-icon dense medium color="white">mdi-receipt-text-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Consumo por item</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item to='/resgates' @click="textoMenu = 'Resgates'" active-class="corMenu" v-if="user.tipo == 'ADMIN'">
          <v-list-item-action>
            <v-icon dense medium color="white">mdi-cash-refund</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Resgates</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/categorias' @click="textoMenu = 'Categorias'" active-class="corMenu" v-if="user.tipo == 'ADMIN' || user.tipo == 'ADMIN_LOJISTA' || user.tipo == 'ADMIN_PRODUTORA'">
          <v-list-item-action>
            <v-icon dense medium color="white">mdi-format-list-group</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Categorias</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/produtos' @click="textoMenu = 'Produtos'" active-class="corMenu" v-if="user.tipo == 'ADMIN' || user.tipo == 'ADMIN_LOJISTA' || user.tipo == 'ADMIN_PRODUTORA'">
          <v-list-item-action>
            <v-icon dense medium color="white">mdi-food</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Produtos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/estoque' @click="textoMenu = 'Estoque'" active-class="corMenu">
          <v-list-item-action>
            <v-icon color="white">mdi-basket</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Estoque</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/fornecedores' @click="textoMenu = 'Fornecedores'" active-class="corMenu" v-if="user.tipo == 'ADMIN' || user.tipo == 'ADMIN_LOJISTA'">
          <v-list-item-action>
            <v-icon dense medium color="white">mdi-truck</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Fornecedores</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/Terminais' @click="textoMenu = 'Terminais'" active-class="corMenu" v-if="user.tipo == 'ADMIN'">
          <v-list-item-action>
            <v-icon color="white">mdi-printer</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Terminals</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/templatesmeta' @click="textoMenu = 'Templates Meta'" active-class="corMenu" v-if="user.tipo == 'ADMIN'">
          <v-list-item-action>
            <v-icon color="white">mdi-message-text</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Templates Meta</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/faturas' @click="textoMenu = 'Faturas'" active-class="corMenu">
          <v-list-item-action>
            <v-icon color="white">mdi-cash-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Faturas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <hr>
        <v-list-item href='https://wa.me/558335125222' target="_blank" active-class="corMenu" @click="textoMenu = 'Suporte'">
          <v-list-item-action>
            <img src="../assets/icon-suporte-fechado.png">
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Suporte</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-navigation-drawer>

    <v-app-bar
      app
      clipped-left
      v-if="usuarioLogado"
      color="#283275" height="60"
    >
      <v-app-bar-nav-icon v-if="user.tipo != 'CAIXA' && user.tipo != 'ATENDENTE'" @click.stop="drawer = !drawer" style="color: white;"></v-app-bar-nav-icon>
      <!-- <p class="textomenu" v-if="this.$vuetify.breakpoint.lg">{{textoMenu}}</p> -->
      <!-- <img v-if="this.$vuetify.breakpoint.lg" src="../assets/logo.png" alt="" height="50" width="auto" class="imagemLogo"> -->
      
      <v-spacer></v-spacer>

      <img src="../assets/logoConsumerBranca.png" style="max-width: 200px" width="100%" v-if="user.tipo == 'ATENDENTE'">

      <v-spacer v-if="user.tipo == 'ATENDENTE'"></v-spacer>

      <!-- MENU USUÁRIO -->    
      <v-menu bottom offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon  dark v-on="on">
            <v-avatar size="40">
              <v-img v-if="user.imagem != ''"  :src="user.imagem"></v-img>
              <v-icon v-else large dark>account_circle</v-icon>
            </v-avatar>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item >
            <v-list-item-avatar>
              <v-img v-if="user.imagem != ''" :src="user.imagem"></v-img>
              <v-icon v-else large light>account_circle</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title style="font-weight: bold;color: grey;">{{user.nome}}</v-list-item-title>
              <v-list-item-subtitle>{{companyobj.nome}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>
      
          <!-- <v-list-item  @click.stop="teste()">
              <v-list-item-title>Editar usuário</v-list-item-title>
          </v-list-item> -->
          <!-- <v-list-item @click.stop="teste()">
              <v-list-item-title>Alterar senha</v-list-item-title>
          </v-list-item> -->
          <!-- <v-list-item @click.stop="teste()">
              <v-list-item-title>Enviar sugestão</v-list-item-title>
          </v-list-item> -->

          <!-- <v-divider></v-divider> -->

          <v-list-item @click="Sair()">
            <v-list-item-title>Sair</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>      
    </v-app-bar>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    props: {
      source: String,
    },
    data() {
      return {
        company: [],
        /* user: [], */
        textoMenu: 'Dashboard',
        drawer: null,
        items: [
          { title: 'Home', icon: 'dashboard' },
          { title: 'About', icon: 'question_answer' },
        ],
        clipped: true,
        mini: false,
        right: null,
        title: 'Controle de Clientes',
      }
    },

    created () {
      //this.$vuetify.theme.dark = false
    },

    mounted: function () { 
      if(sessionStorage.getItem('accToken') != null)                    
        this.$store.dispatch('Logar', this.token)
      if(sessionStorage.getItem('user') != null)
        this.$store.dispatch('SetUser')
      if(sessionStorage.getItem('company') != null)
        this.$store.dispatch('SetCompany')
    },

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj
    }),

    methods:{
      Sair(){
        this.$store.dispatch('Sair')
        this.$router.push({ path: '/login' })
      },

      menuListaCli(){
        this.$router.push({ path: '/lista' })
      },

      menuListaAtend(){
        this.$router.push({ path: '/tipoatend' })
      },

      menuSair(){
        this.$router.push({ path: '/' })
      },

      menuPainels(){
        this.$router.push({ path: '/paineis' })
      },
    }
  }
</script>

<style>
  .v-navigation-drawer{
    width: 60px
  }

  .v-navigation-drawer .v-list .v-list__tile {
    text-decoration: white;
    color: white;
    height: 100%;
    overflow-y: hidden;
    overflow-x: hidden;
  }

  .v-divider{
  margin-top: 0%;
  margin-bottom: 0%;
  }

  .corMenu{
    background-color: #aaaaaa!important;
    border-color: #aaaaaa !important;
  }

  .imagemLogo{
    position:absolute;
    right:50%;
    left:50%;
    margin-right:-50px;
    margin-left:-50px;
  }
  
  .textomenu{
    font-size: 15px;
    position:absolute;
    left:5%;
    color: white;
    /* margin-right:-50px; */
    margin-left:-20px;
  }
  
  hr {
    border: 0;
    width: 100%;
    height: 1px;
    background-image: linear-gradient(to right,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.75),
      rgba(255, 255, 255, 0));
  }

  .titulosmenu{
    font-weight: bold;
    color: grey;
  }
</style>
